import { useEffect, useState } from "react";
import {
  getStoragePersistenceInfo,
  subscribeStoragePersistence,
} from "../local/storagePersistence";

// Read-only companion to useRequestStoragePersistence: any screen that wants
// to know whether THIS station is persistent (StoragePersistenceChip today,
// the Outbox page and the station snapshot payload once G12/G11 exist) reads
// this instead of calling the browser API again. Seeds from whatever the
// meta store already holds (survives a reload) and then stays live off the
// same publish the startup request itself emits, so a chip mounted before
// that first check resolves still updates the moment it does, without
// waiting for its own next mount.
export function useStoragePersistenceStatus() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getStoragePersistenceInfo().then((cached) => {
      if (!cancelled && cached) setInfo(cached);
    });
    const unsubscribe = subscribeStoragePersistence((next) => {
      if (!cancelled) setInfo(next);
    });
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);

  return info;
}

export default useStoragePersistenceStatus;
